import { ProductDonationRecurrenceInterval } from "../enums/product-donation";
import { SubscriptionRecurrenceInterval } from "../types/subscription";
export const isMonthBasedSubscriptionInterval = (recurrenceInterval) => recurrenceInterval === SubscriptionRecurrenceInterval.Monthly ||
    recurrenceInterval === SubscriptionRecurrenceInterval.Quarterly ||
    recurrenceInterval === SubscriptionRecurrenceInterval.Yearly;
const CUMULATIVE_RECEIPT_INTERVALS = new Set([
    ProductDonationRecurrenceInterval.Weekly,
    ProductDonationRecurrenceInterval.BiWeekly,
    ProductDonationRecurrenceInterval.Monthly,
    ProductDonationRecurrenceInterval.Quarterly,
]);
export const hasCumulativeAnnualReceipt = (recurrenceInterval) => !!recurrenceInterval && CUMULATIVE_RECEIPT_INTERVALS.has(recurrenceInterval);
export const isRecurrentProductDonationInterval = (recurrenceInterval) => recurrenceInterval !== ProductDonationRecurrenceInterval.OneTime;
